export default {
  close: 'Close',
};
